<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7tQpkM/tc-custom/9781528957960.jpg?1731166545367" alt="This image is the cover for the book The Long Dark Trail"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Long Dark Trail
      </h1>
      <p class="bookDescription body article font2">
        <p>The Long Dark Trail is an epic, centuries-spanning saga of American life, covering various generations of the Allen family, from their humble origins in England to their friendship with the neighboring Green family and beyond. The two families’ reactions to black emancipation could not be more different: while the Greens choose to give their land away to their former slaves, the Allens remain wedded to the past. By the middle of the twentieth century, the family patriarch Bob Allen continues to pursue his vicious hatred of people of color, even as the ground starts to shift beneath his feet… This extraordinary novel provides a soul-searching account of America’s miraculous, complex history, recounting the triumphs and despairs of generations of white and black Americans joined together by slavery and its aftermath. The country’s changing racial landscape is reflected in the fortunes of the book’s main protagonist, Bob Allen’s daughter Elizabeth, and her biracial “dream son” Jesse.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dawit Tekie Teclemariam
      </h2>
      
      <p class="authorDescription body article">Dawit was born and brought up in Asmara, Eritrea. After completing high school in his homeland, he left for Italy at a young age. He accumulated years of experience in various fields; among these, he was privileged to travel as a sailor across the world, which fueled his vivid and colorful imagination. Despite not having undertaken any formal writing courses, Dawit mulled over The Long Dark Trail (formerly known as The Verdict of Time) for decades, taking inspiration from his many personal experiences as well as from books, films, travels, folklore, people and nature. Dawit first wrote the story in Tigrigna, his native language. He then proceeded to collaborate with an esteemed group of translators to work on the Amharic and English versions simultaneously.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?08c4eedf